import { createSelector } from 'reselect';

const picklistData = (state) => state.picklistData;

export const selectFilterData = () => createSelector([picklistData], (state) => state.filter);

export const selectCreationFormData = () =>
  createSelector([picklistData], (state) => state.creationForm);
